"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

var _blockEditor = require("@wordpress/block-editor");

/**
 * WordPress dependencies
 */
function save() {
  const innerBlocksProps = _blockEditor.useInnerBlocksProps.save(_blockEditor.useBlockProps.save());

  return (0, _element.createElement)("div", innerBlocksProps);
}
//# sourceMappingURL=save.js.map